import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: { logged_in: 0 }
  }
});


// WEBPACK FOOTER //
// ./src/store/index.js